import axiosInstance from '../axios/axios-instance';
import { TodayPlanResponseDto } from 'shared/interfaces/engagement/today-plan/today-plan-response.dto';

export const todayPlanApi = {
  async getTodayPlan(): Promise<TodayPlanResponseDto> {
    const response = await axiosInstance.get<TodayPlanResponseDto>('/engagement/today-plan');
    return response.data;
  },
};
